import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from 'apps/webcomponents/src/utils/request';
import { QuarantineExchangeMethod } from '../types';

export class ExchangeProtectionDataProvider extends BaseWebComponentDataProvider {
  private exchangeEndpoint = 'QuarantineExchange';
  private dataProviderType = DataProviderType.ENDPOINTS;

  public async deleteSelected(payload: { records: Array<any> }) {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: this.dataProviderType,
      payload,
      endpoint: this.exchangeEndpoint,
      method: QuarantineExchangeMethod.CREATE_REMOVE_TASK,
    });
  }

  public async restoreOriginalSelected(payload: { records: Array<any> }) {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: this.dataProviderType,
      payload,
      endpoint: this.exchangeEndpoint,
      method: QuarantineExchangeMethod.CREATE_RESTORE_ORIGINAL_TASK,
    });
  }

  public async emptyQuarantine(payload) {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: this.dataProviderType,
      payload,
      endpoint: this.exchangeEndpoint,
      method: QuarantineExchangeMethod.CREATE_REMOVE_ALL_TASK,
    });
  }

  public async saveSelected(payload: { records: Array<any> }) {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: this.dataProviderType,
      payload,
      endpoint: this.exchangeEndpoint,
      method: QuarantineExchangeMethod.CREATE_SAVE_TASK,
    });
  }

  public async getDataForView() {
    return {};
  }
}
